import React, { Component } from 'react';
import VerticalLayout from "../../components/VerticalLayout/";
import InvoicePage from "./InvoicePage"

class InvoicePreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }        
    }

    componentDidCatch(){
        
        localStorage.getItem("authUser")?this.props.history.push('/itineraries'):this.props.history.push('/404')
    }


    render() {
        
        let obj = JSON.parse(localStorage.getItem("authUser"))

        return (
                obj?
                <VerticalLayout>
                    <InvoicePage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                    />

                </VerticalLayout>

                :

                <InvoicePage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                />
          
        );
    }
}

export default InvoicePreview;


    